import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm, AfterSubmitProps } from 'framework/form';
import useProjectToolsInputData from './useProjectToolsInputData';
import useProjectToolsCreate from './useProjectToolsCreate';
import { Loading } from 'framework/ui/mui-builder';
import FormSubmitButtons from '../common/FormSubmitButtons';
import ProjectToolsFormStepper from './ProjectToolsFormStepper';

interface ProjectToolsFormProps {
  projectId: string;
  relatedProjectId?: string;
  afterSubmit?: AfterSubmitProps<(response: any) => any, string | ((response: any) => any)>;
}

const ProjectToolsForm = ({ projectId, relatedProjectId, afterSubmit }: ProjectToolsFormProps) => {
  const { data, isLoading } = useProjectToolsInputData(projectId, relatedProjectId);
  const { resultStatuses, resultLogs, alreadySubmitted, submit, getValidationSchema } = useProjectToolsCreate();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <CreateForm
      submitFormFunc={submit}
      getDataFunc={() => Promise.resolve(data)}
      afterSubmit={afterSubmit}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout
        buttons={
          <FormSubmitButtons
            isCancelButtonVisible={false}
            submitButtonText={alreadySubmitted ? 'Submit again' : 'Submit'}
          />
        }
      >
        <ProjectToolsFormStepper toolStatuses={resultStatuses} toolLogs={resultLogs} />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default ProjectToolsForm;
